import type { SiteAssetsSkinParam } from '@wix/editor-elements-panel';
import {
  cssPropertyToDefaultValueMap,
  generateSkinDefaults,
} from '@wix/editor-elements-panel';
import { PatternConfig } from './editor/panels/design/patterns.constants';

export type SiteAssetsSkinParams = Record<string, SiteAssetsSkinParam>;

const createPatternSkinParams = (prefix: string, count: number) => {
  const params: SiteAssetsSkinParams = {};
  for (let i = 1; i <= count; i++) {
    params[`${prefix}-pattern-${i}`] = { type: 'CSSString' };
    params[`${prefix}-pattern-${i}-enabled`] = { type: 'CSSString' };
  }
  return params;
};

export const textEffectsSharedSkin = {
  'letter-spacing': {
    type: 'SIZE',
    defaultValue: 'unset',
  },
  'line-height': {
    type: 'SIZE',
    defaultValue: 'unset',
  },
  'text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: 'start',
  },
  'text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: cssPropertyToDefaultValueMap['text-transform'],
  },
  font: {
    type: 'FONT',
    defaultValue: 'font_8',
  },
  minFontSize: {
    type: 'SIZE',
  },
  maxFontSize: {
    type: 'SIZE',
  },
  ...createPatternSkinParams('rotation', PatternConfig.MAX_PATTERNS),
  ...createPatternSkinParams('offset', PatternConfig.MAX_PATTERNS),
  'rotation-pattern-intensity': {
    type: 'CSSString',
    defaultValue: '100',
  },
  'offset-pattern-intensity': {
    type: 'CSSString',
    defaultValue: '100',
  },
  'pattern-preset': {
    type: 'CSSString',
    defaultValue: 'Fridge Magnets',
  },
} as const satisfies SiteAssetsSkinParams;

const textEffectsSharedSkinDefinitionMap: Record<string, SiteAssetsSkinParams> =
  {
    'wixui.skins.TextEffectsShared': textEffectsSharedSkin,
  };

export default generateSkinDefaults(textEffectsSharedSkinDefinitionMap);
